
  import { defineComponent, reactive, toRefs, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { useI18n } from 'vue-i18n';
  import { useRouter } from 'vue-router';

  export default defineComponent({
    name: 'News',
    setup() {
      const store = useStore();
      const i18n = useI18n();
      const router = useRouter();

      const state = reactive({
        loading: false,
        events: [],
      });

      onMounted(() => {
        getAllNews();
      });

      const getAllNews = () => {
        state.loading = true;
        store.dispatch('moduleCommon/getEvents').then((response) => {
          state.loading = false;
          state.events = response.data.docs;
        }).catch(() => {
          state.loading = false;
        });
      };

      const goToNews = () => {
        router.push({ name: 'events' });
      };
      const goToShowNews = (id) => {
        router.push({ name: 'show_events', params: { id: id } });
      };

      return {
        ...toRefs(state),
        store,
        i18n,
        goToNews,
        goToShowNews,
      };
    },
  });
